/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/vue';

declare global {
	interface Window {
		dataLayer?: any;
	}
}

const pushCustomEvent = (data: any) => {
	try {
		window.dataLayer.push(data);
		console.log('gtm_push_custom_event', data);
	} catch (error) {
		console.log({ error });
		Sentry.captureException(error);
	}
};

export const gtmUpdateUser = (
	event = '',
	userID: string | undefined = undefined,
	country: string | undefined = undefined,
) => {
	if (event) {
		pushCustomEvent({ event, userID, country });
	} else {
		pushCustomEvent({ userID, country });
	}
};

export const gtmDirectToLogin = () => {
	pushCustomEvent({ event: 'directToLogin' });
};

export const gtmCheckout = (checkoutID: string) => {
	if (!checkoutID) return;
	pushCustomEvent({ event: 'checkout', checkoutID });
};

export const gtmSubmitOrder = (checkoutID: string, orderID: string, paymentMethodID: number) => {
	pushCustomEvent({ event: 'submitOrder', checkoutID, orderID, paymentMethodID });
};

export const gtmSubmitSearchValue = (searchValue: string) => {
	pushCustomEvent({ event: 'submitSearchValue', searchValue });
};

export const gtmSubmitSortValue = (sortValue: string) => {
	pushCustomEvent({ event: 'submitSortValue', sortValue });
};

export const gtmSubmitSendEmail = (sendTo: string, isMarkSold: boolean) => {
	pushCustomEvent({ event: 'submitSendEmail', sendTo, isMarkSold });
};

export const gtmInitLanguage = (language: string) => {
	pushCustomEvent({ event: 'initLanguage', userLanguage: language });
};

export const gtmChangeLanguage = (language: string) => {
	pushCustomEvent({ event: 'changeLanguage', userLanguage: language });
};
